module.exports = __webpack_public_path__ + "newloader.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/newloader.gif
// module id = 1249
// module chunks = 320